import moment from 'moment';

export const getTodayDate = (format = 'DD.MM.YYYY') => {
  return moment().format(format);
};

export const getYesterdayDate = () => {
  return moment()
    .subtract(1, 'day')
    .format('DD.MM.YYYY');
};

export const timeFromNow = date => {
  const timestamp = moment(date).format('X');
  const newDate = moment.unix(timestamp);
  return moment(newDate).fromNow();
};

export const isToday = date => {
  return moment().isSame(date, 'day');
};

export const getNewDate = (noOfDays, format = 'DD MMM, YYYY') => {
  return moment()
    .add(noOfDays, 'days')
    .format(format);
};

export const getDateElements = date => {
  const dateString = moment(date).format('dddd, MMMM DD YYYY, hh:mm A');
  const dateSections = dateString.split(',');
  const day = dateSections[0];
  const time = dateSections[2];
  const datePart = dateSections[1].trim().split(' ');
  return {
    day,
    time,
    date: {
      dateString: dateSections[1],
      month: datePart[0],
      date: datePart[1],
      year: datePart[2],
    },
  };
};

export const getTime = date => {
  const dateObj = moment(date, 'dddd, MMMM DD YYYY, hh:mm a');
  return moment(dateObj).format('LT');
};

export const isDatesSame = (dateA, dateB) => {
  return moment(dateA).isSame(dateB, 'day');
};

export const isDateAfter = date => {
  const todayDate = getTodayDate('dddd, MMMM DD YYYY, hh:mm a');
  return moment(todayDate).isAfter(date);
};

export const getDateinDesiredFormat = (date, format) => {
  return moment(date).format(format);
};

export const makeJSDateObject = date => {
  if (date) {
    return new Date(date.getTime());
  }
  return date;
};

/**
 * Get Formatted Date
 * @param date
 * @param format
 * @returns {string}
 */
export const getFormattedDate = (date, format = 'YYYY-MM-DD') => {
  if (moment(date, 'YYYY-MM-DD').isValid()) {
    return moment(date).format(format);
  }

  return '';
};

/**
 * Check Is dateTime of Tomorrow
 * @param inputDateTime
 * @returns {boolean}
 */
export const isTomorrow = inputDateTime => {
  const tomorrow = moment()
    .add(1, 'days')
    .format('YYYY-MM-DD');

  return moment(inputDateTime).isSame(tomorrow, 'day');
};

/**
 * Check Is dateTime of Yesterday
 * @param inputDateTime
 * @returns {boolean}
 */
export const isYesterday = inputDateTime => {
  const yesterday = moment()
    .subtract(1, 'days')
    .format('YYYY-MM-DD');

  return moment(inputDateTime).isSame(yesterday, 'day');
};

/**
 * Get Custom Date Time
 * @param value
 * @param unit
 * @param format
 * @returns {string}
 */
export const getCustomDateTime = (value = 0, unit = 'days', format = 'YYYY-MM-DD') => {
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment()
      .add(value, unit)
      .format(format);
  }
};

/**
 * Get Custom Date object
 * @param value
 * @param unit
 * @returns Date object
 */
export const getCustomDateObject = (value = 0, unit = 'days') => {
  if (value === 0) {
    return moment();
  } else {
    return moment().add(value, unit);
  }
};

export const getDateText = date => {
  if (isToday(date)) {
    return 'Today';
  } else if (isYesterday(date)) {
    return 'Yesterday';
  } else if (isTomorrow(date)) {
    return 'Tomorrow';
  } else {
    return date;
  }
};

export const getTimeDiffString = (date, format = 'DD MMM, YYYY', suffix = '') => {
  const postDate = moment(date, 'ddd MMM DD YYYY kk:mm:ss Z');
  const currentDate = moment();
  const duration = moment.duration(currentDate.diff(postDate));
  const minutes = duration.asMinutes() | 0;
  const hours = duration.asHours() | 0;

  switch (true) {
    case minutes === 0:
      return 'Just now';
    case minutes < 60:
      return `${minutes} min ${suffix}`;
    case hours < 24:
      return `${hours} hours ${suffix}`;
    default:
      return postDate.format(format);
  }
};

export function formatUTCToPacificTime(utcInSeconds){
  if (!utcInSeconds) return ""
  utcInSeconds = new Date(utcInSeconds*1000)
  let dateTime = utcInSeconds.toLocaleString('en-US', {
    hour12: false,
    timeZone: 'America/Los_Angeles',
    timeZoneName: 'short',
    hour: '2-digit',
    minute:'2-digit',
    month: '2-digit',
    day: '2-digit',
  })
  let [date, time, timeZone] = dateTime.replace(", ", " ").split(" ")
  if (time.split(':')[0] === '24') time = '00:' + time.split(':')[1];
  return `${time} ${timeZone} - ${date}`
}

export function formatUTCToPacificTimeNormalFormat(utcInSeconds){
  if (!utcInSeconds) return ""
  utcInSeconds = new Date(utcInSeconds*1000)
  let dateTime = utcInSeconds.toLocaleString('en-US', {
    hour12: false,
    timeZone: 'America/Los_Angeles',
    timeZoneName: 'short',
  })
  let [date, time, timeZone] = dateTime.replaceAll("/", "-").replaceAll(",", "").split(" ");
  time = time.split(":").splice(0,2).join(":")
  return `${date} ${time} - ${timeZone}`
}

export function formatDateTimeString(dateTimeString){
  if(!dateTimeString)return "";
  let [date, time] = dateTimeString.split("T")
  time = time.split(":").splice(0,2).join(":")
  return `${date} ${time}`
}

export function formatToDaysHoursAndSeconds(seconds){
  var seconds = parseInt(seconds, 10);
  var days = Math.floor(seconds / (3600*24));
  seconds  -= days*3600*24;
  var hrs   = Math.floor(seconds / 3600);
  seconds  -= hrs*3600;
  var mnts = Math.floor(seconds / 60);
  seconds  -= mnts*60;
  return `${days ? days+"D ":""}${hrs ? hrs+"H ":""}${mnts ? mnts+"Min":""}`
}

export function getTimeFromNow(epochTime,currentEpochTime){
  let deltaSecond;
  if(currentEpochTime){
    deltaSecond = currentEpochTime - epochTime;
  }else{
    deltaSecond = (new Date()).getTime() / 1000 - epochTime;
  }
  return moment().subtract(deltaSecond, 'second').fromNow();
}

export function getTimeFromNowShort(epochTime,currentEpochTime){ //returns time diff like 1min, 2w, 5m, 2y etc
  let timeStr = getTimeFromNow(epochTime, currentEpochTime)
  if(timeStr.includes("second"))return "1min"

  let count = timeStr.split(" ")[0]
  if (count === "a" || count === "an")count = "1"

  let timeUnit = ""
  if(timeStr.includes("minute"))timeUnit = "min"
  if(timeStr.includes("hour"))timeUnit = "h"
  if(timeStr.includes("day"))timeUnit = "d"
  if(timeStr.includes("week"))timeUnit = "w"
  if(timeStr.includes("month"))timeUnit = "m"
  if(timeStr.includes("year"))timeUnit = "y"

  return count+timeUnit;
}